import * as classNames from "classnames";
import * as React from 'react';
import { Control, LocalForm } from "react-redux-form";
import { withTheme } from '../../common/withTheme';
import * as Configuration from '../../configuration';
import InternalClassificationLink from "../Framework/Common/Links/InternalClassificationLink";

interface ILoginSmallProps {
    className?: string;
    theme?: string;
}

interface ILoginSmallActions {
    login: any;
}

export interface ILoginSmallState {
    showForm?: boolean;
}

type LoginSmallProps = ILoginSmallProps & ILoginSmallActions;

class LoginSmall extends React.PureComponent<LoginSmallProps, ILoginSmallState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);

        this.state = { showForm: false };
    }

    onLoginFormClick(login) {
        this.props.login(login.username, login.password);
    }

    render() {
        const loginForm = Configuration.custom.showBannerLoginForm ?
            <div className="row">
                <LocalForm
                    model="login"
                    className={classNames(this.props.theme, this.props.className, "form-inline d-none d-lg-block")}
                    onSubmit={login => this.onLoginFormClick(login)}
                    getDispatch={(dispatch) => this.formDispatch = dispatch}
                    validateOn="submit">
                    <div className="form-group mb-0" >
                        <Control.text
                            model=".username"
                            id="loginSmall.Email"
                            className="form-control form-control-sm login"
                            maxLength={255}
                        >
                        </Control.text>
                        <Control.text
                            model=".password"
                            type="password"
                            className="form-control form-control-sm login"
                            id="loginSmall.password"
                            maxLength={255}
                        >
                        </Control.text>
                        <button type="submit" className={`${this.props.theme} btn btn-secondary btn-sm`}>LOGIN</button>
                    </div>
                </LocalForm>
                {InternalClassificationLink("user/login", "LOGIN", undefined, classNames(this.props.theme, "btn btn-secondary btn-md-sm btn-lg m-1 d-block d-lg-none"))}
                {InternalClassificationLink("user/register", "REGISTER", undefined, classNames(this.props.theme, "btn btn-secondary btn-md-sm btn-lg m-1 d-block d-lg-none"))}
            </div> :
            <div>
                {InternalClassificationLink("user/login", "LOGIN", undefined, `${this.props.theme} btn btn-light btn-sm`)}
            </div>;

        return (loginForm);
    }
}

export default withTheme<LoginSmallProps>(LoginSmall);
